<template>
  <button
    v-if="recipeId"
    @click="performToggleInterest"
    class="btn btn-interest"
    :disabled="internalInterestInProgress"
    title="Интересно / В избранное"
  >
    <i
      :class="
        internalIsInterested
          ? 'bi bi-bookmark-fill text-warning'
          : 'bi bi-bookmark'
      "
    ></i>
  </button>
</template>

<script>
export default {
  name: "RecipeInterest",
  props: {
    recipeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      internalIsInterested: false,
      internalInterestInProgress: false,
    };
  },
  watch: {
    recipeId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.checkInterestStatus();
        } else {
          this.internalIsInterested = false;
        }
      },
    },
    "$globalState.apiUrl"(newApiUrl, oldApiUrl) {
      if (newApiUrl && !oldApiUrl && this.recipeId) {
        this.checkInterestStatus();
      }
    },
  },

  methods: {
    async performToggleInterest() {
      if (!this.recipeId || this.internalInterestInProgress) return;
      if (!this.$globalState.apiUrl) {
        console.error(
          "RecipeInterest: API URL not available, cannot toggle interest."
        );
        return;
      }

      this.internalInterestInProgress = true;
      const command = this.internalIsInterested
        ? `user.interest.remove/${this.recipeId}`
        : `user.interest.add/${this.recipeId}`;
      try {
        await this.sendCmd(command);
        this.internalIsInterested = !this.internalIsInterested;
        this.$emit(
          "interest-toggled",
          this.internalIsInterested,
          this.recipeId
        );
      } catch (error) {
        console.error("RecipeInterest: Error toggling interest:", error);
        this.$emit("interest-error", error);
      } finally {
        this.internalInterestInProgress = false;
      }
    },
    async checkInterestStatus() {
      if (!this.recipeId) {
        this.internalIsInterested = false;
        return;
      }
      if (!this.$globalState.apiUrl) {
        console.warn(
          "RecipeInterest: API URL not available, cannot check interest status for recipeId:",
          this.recipeId
        );
        return;
      }

      try {
        const command = `user.recipe.isInterested/${this.recipeId}`;
        const response = await this.sendCmd(command);
        if (typeof response === "string") {
          this.internalIsInterested = JSON.parse(response).is_interested;
        } else if (
          typeof response === "object" &&
          response !== null &&
          typeof response.is_interested === "boolean"
        ) {
          this.internalIsInterested = response.is_interested;
        } else {
          this.internalIsInterested = false; // Default on unexpected format
        }
      } catch (error) {
        console.error(
          `RecipeInterest: Error checking interest status for ${this.recipeId}:`,
          error
        );
        this.internalIsInterested = false; // Default to not interested on error
      }
    },
  },
};
</script>

<style scoped>
.btn-interest {
  background: none;
  border: none;
  margin-bottom: 12px;
  font-size: 1.5rem;
  padding: 0;
}
</style>
